import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { setFilters } from "../../../actions/restaurantActions";
import { connect } from "react-redux";
import CloseIcon from "../../icons/CloseIcon";
import SearchIcon from "../../icons/SearchIcon";

const SearchBar = ({
  history,
  setFilters,
  restaurants,
  mobileSearch,
  toggleFilterTakeover,
  clearAllChecks,
}) => {
  const { restaurantListAll } = restaurants;
  const text = useRef("");

  const [searchList, setSearchList] = useState();

  let searchResultsList;

  const searchRestaurants = () => {
    if (!restaurantListAll || restaurantListAll.length === 0) {
      return;
    }

    if (text.current.value.length < 2) return;

    let regex = new RegExp(
      text.current.value
        .toLowerCase()
        .replace(/'/g, "")
        .replace(/[^a-zA-Z0-9 ]/g, "")
    );

    searchResultsList = restaurantListAll.filter(restaurant => {
      return (
        restaurant.slug.split("-").join(" ").toLowerCase().search(regex) !== -1
      );
    });

    if (searchResultsList.length > 8)
      searchResultsList = searchResultsList.slice(0, 8);
    setSearchList(searchResultsList);
    if (typeof window !== `undefined`) {
      const searchResult = document.getElementById("search-list");
      const searchResultMobile = document.getElementById("search-list--mobile");
      if (searchResultMobile) searchResultMobile.style["display"] = "block";
      if (searchResult) searchResult.style["display"] = "block";
    }
  };

  //if user selects a restaurant from search results, show restaurant card
  const updateList = e => {
    clearAllChecks();
    const restId = e.currentTarget.id;

    setFilters(
      {
        restaurantSearchFilter: restId,
      },
      history,
      restaurants
    );

    if (mobileSearch) toggleFilterTakeover();

    setSearchList(null);
    if (typeof window !== `undefined`) {
      const searchResult = document.getElementById("search-list");
      const searchResultMobile = document.getElementById("search-list--mobile");
      if (searchResult) searchResult.style["display"] = "none";
      if (searchResultMobile) searchResultMobile.style["display"] = "none";
      text.current.value = "";
      let closeIcon = document.querySelectorAll(".close-search");
      closeIcon = Array.from(closeIcon);
      closeIcon.forEach(icon => icon.classList.add("hidden"));
      let searchIcon = document.querySelectorAll(".search-icon");
      searchIcon = Array.from(searchIcon);
      searchIcon.forEach(icon => icon.classList.remove("invisible"));

      //if mobile, scroll to top of results.
      if (
        window.matchMedia("(pointer: coarse)").matches ||
        window.matchMedia("(hover: none)").matches
      ) {
        setTimeout(function () {
          const targetElement = document.querySelector(".num-of-results-text");
          if (targetElement)
            targetElement.scrollIntoView({ block: "start", inline: "start" });
        }, 500);
      } else {
        const targetResults = document.querySelector(".results");
        // if (targetResults) targetResults.scrollIntoView(true);

        const targetElement = document.querySelector(".restaurant-list");
        if (targetElement) targetElement.scrollTop = 0;
      }
    }
  };

  const clearSearch = () => {
    searchResultsList = restaurantListAll;
    setSearchList(null);
    if (typeof window !== `undefined`) {
      const searchResult = document.getElementById("search-list");
      const searchResultMobile = document.getElementById("search-list--mobile");
      if (searchResult) searchResult.style["display"] = "none";
      if (searchResultMobile) searchResultMobile.style["display"] = "none";
      text.current.value = "";
      let closeIcon = document.querySelectorAll(".close-search");
      closeIcon = Array.from(closeIcon);
      closeIcon.forEach(icon => icon.classList.add("hidden"));
      let searchIcon = document.querySelectorAll(".search-icon");
      searchIcon = Array.from(searchIcon);
      searchIcon.forEach(icon => icon.classList.remove("invisible"));
    }
  };

  const onChange = e => {
    if (text.current.value !== "" && typeof window !== "undefined") {
      let closeIcon = document.querySelectorAll(".close-search");
      closeIcon = Array.from(closeIcon);
      closeIcon.forEach(icon => icon.classList.remove("hidden"));
      let searchIcon = document.querySelectorAll(".search-icon");
      searchIcon = Array.from(searchIcon);
      searchIcon.forEach(icon => icon.classList.add("invisible"));
      searchRestaurants();
    } else {
      clearSearch();
    }
  };

  return (
    <form
      id={mobileSearch ? "search-form--mobile" : "search-form"}
      className="dropdown-search"
    >
      <div className="spread">
        <input
          className="search-box"
          type="text"
          ref={text}
          placeholder={`Search by restaurant name...`}
          onChange={onChange}
        />
        <span onClick={clearSearch} className="close-search hidden">
          <CloseIcon />
        </span>
        <span className="search-icon">
          <SearchIcon />
        </span>
      </div>
      <div id={mobileSearch ? "search-list--mobile" : "search-list"}>
        {(!searchList || (searchList && searchList.length === 0)) && (
          <div className="restaurant-search-card">
            <div className="restaurant-search-card__container">
              <p className="restaurant-search-card__error">
                Please try another search
              </p>
            </div>
          </div>
        )}
        {searchList &&
          searchList.map(restaurant => {
            return (
              <div key={restaurant.id} className="restaurant-search-card">
                <div
                  onClick={updateList}
                  className="restaurant-search-card__link"
                  id={restaurant.id}
                >
                  <div className="restaurant-search-card__container">
                    <p className="restaurant-search-card__name">
                      {restaurant.name}
                    </p>
                    {/* <div className="restaurant-search-card__tags">
                      {restaurant.cuisine.map(cuisine => {
                        return (
                          <p
                            className="restaurant-search-card__tag-text"
                            key={cuisine}
                          >
                            {cuisine}
                          </p>
                        );
                      })}
                    </div> */}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </form>
  );
};

SearchBar.propTypes = {
  setFilters: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  restaurants: state.restaurants,
});

export default connect(mapStateToProps, {
  setFilters,
})(SearchBar);
